import useMatchBreakpoint from './use-match-breakpoint';
import { breakpoints } from '../constants';

const useMatchXSBreakpoint = () => {
  const matches = useMatchBreakpoint(breakpoints.xs);

  return matches;
};

export default useMatchXSBreakpoint;
